// @flow
import cn from 'classnames';
import React, { useEffect } from 'react';

import Button from '../../../../ui-components/Editor/Button';
import { getTitleFontClass, getMainFontClass } from '../../../../utils/common-helper';
import { getNewsHash } from '../../../../utils/news-helper';

import './style.pcss';

type Props = {
  date: string,
  title: string,
  description: string,
  onClick: () => void,
  onScrollToPacks?: () => void,
  buttonText: string,
  imageUrl: string,
  landingTheme: Object,
  isPrivate?: boolean,
  privateJoinText?: string,
  privateDescription?: string
};

const NewsBanner = ({
  date,
  title,
  description,
  onClick,
  onScrollToPacks,
  buttonText,
  imageUrl,
  landingTheme,
  isPrivate = false,
  privateJoinText = '',
  privateDescription = ''
}: Props) => {
  useEffect(() => {
    const currentHash = window.location.hash;
    const newsHash = getNewsHash(title);
    if (newsHash === currentHash) {
      onClick();
    }
  });

  return (
    <div className='swiper-slide'>
      <div className='banner-content'>
        <div className='banner-image' style={{ backgroundImage: `url("${encodeURI(imageUrl)}")` }}>
          {isPrivate && (
            <div className='banner-image__description-wrapper'>
              <div className='banner-image__description'>{privateDescription}</div>
              <button className='banner-button__join' onClick={onScrollToPacks}>
                <span className='simple-button__text'>{privateJoinText}</span>
              </button>
            </div>
          )}
        </div>
        <div className={cn(
          'banner-news',
          'ui-site-description',
          'custom-header-font',
          getTitleFontClass(landingTheme.headerFont)
        )}
        >
          <div className={cn(
            'banner-meta-info',
            'ui-site-description--small',
            getMainFontClass(landingTheme.mainFont)
          )}
          >
            <span>{date}</span>
          </div>
          <h3>{title}</h3>
          <p className={cn('news-text', getMainFontClass(landingTheme.mainFont))}>
            {description}
          </p>
          {!isPrivate && (
            <Button onClick={onClick}>
              {buttonText}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewsBanner;
